import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import AutoScrollingInfos from "./AutoScrollingInfos";
const AutoScrollingInfosPreview = () => {
    return (_jsx(AutoScrollingInfos, { dynamicList: [
            {
                title: "Titre 1",
            },
            {
                title: "Titre 2",
            },
            {
                title: "Titre 3",
            },
        ] }));
};
export default AutoScrollingInfosPreview;
